export default __webpack_public_path__ + "static/media/print.31400256.svg";